import React from 'react';

const OptionalItem = props => (
  <div
    className="OptionalItem"
    style={{width: props.width, ...props.style}}
  >
    任意
  </div>
);

export default OptionalItem;
